import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTimes } from '@fortawesome/free-solid-svg-icons';
import SearchBar from '../detail/tabs/SearchBar';
import { nextCustomCode } from './configCodes';

/** Modal: pick one SNOMED code or enter free text to add to a configured code list */
const AddConfiguredCodeModal = ({
  isOpen,
  onClose,
  onPick,
  handleCodeSearch,
  existingCodes,
  title,
  freeTextPlaceholder,
}) => {
  const [activeTab, setActiveTab] = useState('snomed');
  const [freeText, setFreeText] = useState('');
  const [freeTextError, setFreeTextError] = useState('');

  useEffect(() => {
    if (isOpen) {
      setActiveTab('snomed');
      setFreeText('');
      setFreeTextError('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleFreeTextSubmit = () => {
    const trimmed = freeText.trim();
    if (!trimmed) {
      setFreeTextError('Please enter a label.');
      return;
    }
    const duplicate = Object.values(existingCodes || {}).some(
      (c) => c.terms?.[0]?.toLowerCase() === trimmed.toLowerCase()
    );
    if (duplicate) {
      setFreeTextError('That label is already in the list.');
      return;
    }
    onPick({ code: nextCustomCode(existingCodes), terms: [trimmed] });
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container modal-animated">
        <div className="modal-header">
          <h2>{title}</h2>
          <button type="button" className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <div className="modal-content">
          <div className="add-code-tab-toggle">
            <button
              type="button"
              className={`add-code-tab-btn ${activeTab === 'snomed' ? 'is-active' : ''}`}
              onClick={() => { setActiveTab('snomed'); setFreeTextError(''); }}
            >
              Search SNOMED
            </button>
            <button
              type="button"
              className={`add-code-tab-btn ${activeTab === 'freetext' ? 'is-active' : ''}`}
              onClick={() => { setActiveTab('freetext'); setFreeTextError(''); }}
            >
              <FontAwesomeIcon icon={faPencil} style={{ marginRight: '6px' }} />
              Free text
            </button>
          </div>
          {activeTab === 'snomed' ? (
            <>
              <p className="retention-description" style={{ marginBottom: '12px' }}>
                Search SNOMED and select one concept to add. If the concept is already in the list you will see an error message.
              </p>
              <SearchBar
                placeholder="Search for a SNOMED code…"
                onSearch={handleCodeSearch}
                onResultClick={onPick}
                className="measurement-search-bar"
              />
            </>
          ) : (
            <>
              <p className="retention-description" style={{ marginBottom: '12px' }}>
                Enter a custom label. It will be stored as a free-text entry with no SNOMED code.
              </p>
              <input
                type="text"
                className="configured-code-term-input"
                value={freeText}
                onChange={(e) => { setFreeText(e.target.value); setFreeTextError(''); }}
                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleFreeTextSubmit(); } }}
                placeholder={freeTextPlaceholder}
                autoFocus
              />
              {freeTextError && (
                <p className="retention-description" style={{ color: '#dc3545', marginTop: '8px' }}>
                  {freeTextError}
                </p>
              )}
            </>
          )}
        </div>
        <div className="modal-actions">
          <button type="button" className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          {activeTab === 'freetext' && (
            <button
              type="button"
              className="admin-submit-button"
              onClick={handleFreeTextSubmit}
              disabled={!freeText.trim()}
            >
              Add
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddConfiguredCodeModal;
